import React from 'react';
import logo from '../assets/images/vine-centre-logo.png';
import building from '../assets/images/vine_centre_advert[1].jpg';

const team = [
  { name: 'Stephen Reid', img: require('../assets/images/Stephen_7046.jpg'), role: 'Centre Manager', bio: '' },
  { name: 'Sherrie Beattie', img: require('../assets/images/Sherrie_1874.jpg'), role: 'Bulrush Day Nursery Manager', bio: '' },
  { name: 'Claire Adams', img: require('../assets/images/Claire_7554.jpg'), role: 'Admin & Finance', bio: '' },
  { name: 'Elizabeth Anderson', img: require('../assets/images/Elizabeth_7512.jpg'), role: 'Education Officer', bio: '' },
  { name: 'Tracey Robinson', img: require('../assets/images/Tracey_8521.jpg'), role: 'Afterschools Co-ordinator', bio: '' },
  { name: 'David Surgenor', img: require('../assets/images/David_3493.jpg'), role: 'Pastoral Support Worker', bio: '' },
  { name: 'Heather Mehaffy', img: require('../assets/images/Heather_2737.jpg'), role: 'Advice Worker', bio: '' },
  { name: 'Andy McCann', img: require('../assets/images/Andy_8664.jpg'), role: 'Advice Assistant', bio: '' },
  { name: 'Stanley Acheson', img: require('../assets/images/Stanley_4991.jpg'), role: 'Caretaker/Cleaner', bio: '' },
];

export default function WhosWho() {
  return (
    <div className="whoswho-root">
      <div className="aboutus-hero">
        <img src={building} alt="Vine Centre Building" className="aboutus-hero-bg" />
        <div className="aboutus-hero-overlay"></div>
        <div className="aboutus-hero-content">
          <img src={logo} alt="Vine Centre Logo" className="aboutus-logo" />
          <h1>Who’s Who</h1>
          <p>Meet the team behind the Vine Centre</p>
        </div>
      </div>
      <div className="whoswho-grid-soft">
        {team.map((person, idx) => (
          <div className="whoswho-card-soft" key={idx}>
            <div className="whoswho-avatar-frame">
              <img src={person.img} alt={person.name} className="whoswho-avatar" />
            </div>
            <div className="whoswho-info-soft">
              <div className="whoswho-name-soft">{person.name}</div>
              <div className="whoswho-role-soft">{person.role}</div>
            </div>
          </div>
        ))}
      </div>
      <style>{`
        .whoswho-root {
          max-width: 1100px;
          margin: 0 0 0 32px;
          padding: 0 16px 48px 16px;
          background: #f7f8fa;
        }
        .aboutus-hero {
          position: relative;
          width: 100%;
          max-width: 1100px;
          min-height: 260px;
          border-radius: 22px;
          overflow: hidden;
          margin: 0 auto 40px auto;
          box-shadow: 0 8px 32px rgba(123,30,58,0.13);
          background: linear-gradient(120deg, var(--vine-main) 0%, var(--vine-accent) 100%);
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .aboutus-hero-bg {
          width: 100%;
          height: 260px;
          object-fit: cover;
          opacity: 0.18;
          position: absolute;
          top: 0; left: 0;
          z-index: 1;
        }
        .aboutus-hero-overlay {
          position: absolute;
          top: 0; left: 0; right: 0; bottom: 0;
          background: linear-gradient(120deg, rgba(123,30,58,0.18) 0%, rgba(255,255,255,0.10) 100%);
          z-index: 2;
        }
        .aboutus-hero-content {
          position: relative;
          z-index: 3;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 100%;
          padding: 32px 0 24px 0;
        }
        .aboutus-logo {
          height: 90px;
          background: #fff;
          border-radius: 18px;
          padding: 12px;
          box-shadow: 0 2px 12px rgba(123,30,58,0.10);
          margin-bottom: 10px;
        }
        .aboutus-hero-content h1 {
          color: var(--vine-secondary);
          font-weight: 900;
          font-size: 2.7rem;
          text-shadow: 0 2px 12px rgba(44,0,0,0.18);
          margin: 0;
          letter-spacing: 1px;
        }
        .aboutus-hero-content p {
          color: var(--vine-secondary);
          font-weight: 500;
          font-size: 1.18rem;
        }
        .whoswho-grid-soft {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 2.2rem;
          margin: 0 auto;
          max-width: 1100px;
          width: 100%;
        }
        @media (max-width: 1000px) {
          .whoswho-grid-soft {
            grid-template-columns: repeat(3, 1fr);
          }
        }
        @media (max-width: 700px) {
          .whoswho-grid-soft {
            grid-template-columns: repeat(2, 1fr);
            gap: 1.2rem;
          }
        }
        .whoswho-card-soft {
          background: #fff;
          border-radius: 16px;
          box-shadow: 0 2px 12px rgba(123,30,58,0.08);
          padding: 1.1rem 0.7rem 1.1rem 0.7rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          transition: box-shadow 0.18s, transform 0.18s;
          position: relative;
          width: 180px;
          min-width: 180px;
          max-width: 180px;
          min-height: 260px;
          margin: 0 auto;
        }
        .whoswho-card-soft:hover {
          box-shadow: 0 8px 32px rgba(123,30,58,0.13);
          transform: translateY(-4px) scale(1.03);
        }
        .whoswho-avatar-frame {
          width: 96px;
          height: 96px;
          border-radius: 50%;
          overflow: hidden;
          margin-bottom: 1.1rem;
          border: 3px solid #7b1e3a;
          background: #f3f6fa;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .whoswho-avatar {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 50%;
        }
        .whoswho-info-soft {
          margin-top: 0.2em;
        }
        .whoswho-name-soft {
          font-size: 1.11rem;
          font-weight: 800;
          color: #7b1e3a;
          margin-bottom: 0.18em;
        }
        .whoswho-role-soft {
          font-size: 1.01rem;
          font-weight: 500;
          color: #3a6c5a;
        }
        @media (max-width: 1200px) {
          .whoswho-root, .aboutus-hero, .whoswho-grid-soft {
            max-width: 100%;
          }
        }
      `}</style>
    </div>
  );
}
